export const applicationsPageStyles = {
  row: {
    paddingTop: 8,
    paddingBottom: 16,
    borderBottom: "1px solid #d6d6d6",
    "&:hover": {
      background: "#f7f7f7",
    },
  },
  header: {
    paddingLeft: 8,
    paddingBottom: 4,
  },
  disabled: {
    color: "black",
  },
  chip: {
    marginLeft: 8,
  },
  secondary: {
    fontSize: "12px",
    color: "gray",
    paddingLeft: 8,
    paddingRight: 8,
  },
  copyButton: {
    marginRight: 8,
    marginTop: 2,
  },
};
